import { useState, useCallback } from "react";
export const useInput = () => {
  const [formState, setFormState] = useState({
    enteredValue: "",
    isValid: false,
    isTouched: false,
    error: {
      hasError: false,
      errorName: "",
    },
  });

  const changeInputHandler = (event) => {
    const enteredValue = event.target.value;
    setFormState((prevState) => {
      return {
        ...prevState,
        enteredValue,
        isTouched: true,
      };
    });
  };
  const blurInputHandler = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        isTouched: true,
      };
    });
  };

  const noError = () => {
    setFormState((prevState) => {
      return {
        ...prevState,
        isValid: true,
        error: {
          hasError: false,
          errorName: "",
        },
      };
    });
  };

  const error = (errorName) => {
    setFormState((prevState) => {
      return {
        ...prevState,
        isValid: false,
        error: {
          hasError: true,
          errorName,
        },
      };
    });
  };
  const validateMobile = useCallback((config) => {
    const isValid =
      (isNaN(config.value) ? false : true) &&
      config.value.trim().length === 11;
    if (isValid) {
      return noError();
    }
    return error("Not a valid mobile number");
  }, []);

  const validateEmail = useCallback((config) => {
    const isValid = config.value.includes("@");

    if (isValid) {
      return noError();
    }
    return error("Email is not valid");
  }, []);
  const validateValue = useCallback(
    (config) => {
      if (config.value.trim().length === 0) {
        error("This Field is Required");
      } else {
        if (config.type === "text") {
          noError();
        }
        if (config.type === "mobile") {
          validateMobile(config);
        }
        if (config.type === "email") {
          validateEmail(config);
        }
      }
    },
    [validateEmail, validateMobile]
  );

  return {
    formState,
    validateValue,
    changeInputHandler,
    blurInputHandler,
  };
};
